import { useFormContext } from 'react-hook-form';
import ErrorMessage from 'components/ui/ErrorMessage/ErrorMessage';
import SelectInput from '../../forms/SelectInput';
import SubmitButton from '../../forms/SubmitButton';
import { useBreakpoint } from '../../BreakpointProvider';

const CaptainDeclineContent = ({ resizeIframe }) => {
  const { register, errors, watch } = useFormContext();

  const breakpoints = useBreakpoint();
  const smallScreen = breakpoints.xs || breakpoints.sm;

  const reasons = () => [
    { value: 'No longer available to captain', label: 'No longer available to captain' },
    { value: 'Too many passengers', label: 'Too many passengers' },
    { value: 'Weather', label: 'Weather' },
    { value: 'Other', label: 'other' },
  ];

  return (
    <div>
      <div className="u-mb1">
        <div className="Select u-sizeFull">
          <SelectInput
            name="category"
            capitalOption
            labelName="Reason"
            options={reasons()}
            showError
            placeholder="Select a reason..."
            userType="captain"
            callback={() =>
              setTimeout(() => {
                const extraSpacing = smallScreen ? 0 : 0;
                resizeIframe(extraSpacing);
              }, 100)
            }
            onChange={() =>
              setTimeout(() => {
                resizeIframe();
              }, 100)
            }
          />
        </div>
      </div>
      {watch('category') === 'Other' && (
        <div className="u-mb1">
          <div className="js-other-reason-textarea">
            <textarea
              ref={register}
              className="Textarea u-sizeFull"
              name="reason_text"
              placeholder="Details (optional)"
              rows={5}
              defaultValue=""
            />
          </div>
          <ErrorMessage error={errors.reason_text} message="This field is required." />
        </div>
      )}
      <div className="Grid Grid--withGutter">
        <div className="Grid-cell u-size3of4 u-sm-sizeFull">
          <div className="Grid Grid--withGutter">
            <div className="Grid-cell u-size2of3 u-sm-sizeFull">
              <SubmitButton
                dataTestId="action-cta"
                disabled={false}
                additionalClasses="Button--aquamarine u-sizeFull u-sm-mb1"
              >
                Decline booking
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaptainDeclineContent;
